import { mutations } from 'RestAPIs/rapini';
import { showSuccessSnackbar } from 'components/shared/Snackbar';
import showError from 'components/shared/showError';
import { useQueryClient } from 'react-query';

export const useRemoveDayLimitArrangement = () => {
  const queryClient = useQueryClient();

  return mutations.useDeleteDayLimitArrangementForEmployee({
    onSuccess: () => {
      showSuccessSnackbar();
      queryClient.invalidateQueries(['getDayLimitArrangementsForEmployee']);
    },
    onError: (error) => {
      showError(error as any);
    }
  });
};

export default useRemoveDayLimitArrangement;
